import React, { Suspense } from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import LoginContainer from './containers/LoginContainer';
import DashboardComponent from './components/DashboardComponent';
import PageNotFound from './components/PageNotFound';
import './App.css';
import AccountSelectionComponentWithTranslation from './components/AccountSelectionComponent';
import { withUser } from './components/utils/AuthHOC';
import { PulseLoader } from 'react-spinners';

const App = () => (
    <Suspense
        fallback={
            <div className="loader-fb">
                <PulseLoader color="#094063" size={7} />
            </div>
        }
    >
        <Router history="">
            <div className="content">
                <Switch>
                    <Route path="/" exact render={(props) => <Redirect to="/dashboard" />} />
                    <Route component={LoginContainer} path="/login" exact />
                    <Route component={withUser(DashboardComponent)} path="/dashboard" />
                    <Route
                        component={AccountSelectionComponentWithTranslation}
                        path="/select-account"
                    />
                    <Route component={PageNotFound} />
                </Switch>
            </div>
        </Router>
    </Suspense>
);

export default App;
